<div class="common-ui-lib-status-ui-card-eric-error-page">
<!--  <h6>vol: {{(taskVolume$ |async) / 1000000}}Mb count: {{documents$.value?.length }}</h6>-->
  <h2 class="mb-5x">
    {{ 'COMMON_UI.FRAGEBOGEN.ANHAENGE.TITEL' | translate }}
  </h2>

  <div class="dropzone" [ngClass]="(uploadDisabled$ | async) ?'disabled':''">
    <div *ngIf="!(adding$ | async)" class="frame " [ngClass]="(borderHighlight$ | async) ? 'drag' : ''">
      <input #fileDropRef id="fileDropRef" class="form-control" type="file" (change)="add($event)" multiple
             aria-label="file input" [disabled]="uploadDisabled$ | async"
             accept="{{supportedMimeTypes}}" (dragenter)="onDrag(true)" (dragleave)="onDrag(false)"/>
      <div *ngIf="!(maxDocumentsReached$ | async)" class="active-upload">
        <h5 for="fileDropRef" class="inner-top"> {{ 'COMMON_UI.FRAGEBOGEN.ANHAENGE.DOKUMENTE_ZIEL' | translate }}</h5>
        <p>{{ 'COMMON_UI.FRAGEBOGEN.ANHAENGE.ODER' | translate }}</p>
        <button class="btn btn-default mt-2x"
                (click)="fileDropRef.click()"> {{ 'COMMON_UI.FRAGEBOGEN.ANHAENGE.DOKUMENTE_IMPORT' | translate }} </button>
      </div>
      <div *ngIf="maxDocumentsReached$ | async" class="p-md-8x max-warn">
        <div class="warn-symbol"></div>
        <p class="mt-2x"> {{ 'COMMON_UI.FRAGEBOGEN.ANHAENGE.ERRORS.VOLUME_EXCEEDED_DROPZONE1' | translate }}</p>
        <p class="mt-3x"> {{ 'COMMON_UI.FRAGEBOGEN.ANHAENGE.ERRORS.VOLUME_EXCEEDED_DROPZONE2' | translate }}</p>
      </div>
    </div>
    <div *ngIf="(adding$ | async)" class="frame loading">
      <div class="dna-loader-container dna-loader-loop-lg">
        <div class="dna-loader-loop">
          <div class="loader"></div>
        </div>
        <div class="progress-text">{{ 'COMMON_UI.FRAGEBOGEN.ANHAENGE.HOCHLADEN' | translate }}</div>
      </div>
    </div>
  </div>

  <div *ngIf="!(loading$ |async) && documents$.value && documents$.value.length > 0 ">
    <h3 class="pt-8x">
      {{ 'COMMON_UI.FRAGEBOGEN.ANHAENGE.HOCHGELADENE' | translate }}
    </h3>
    <ul class="list-group d-flex mb-8x">
      <li *ngFor="let att of documents$ | async" class="list-group-item ">
        <div class="file-entry">
          <button class="btn-link list-group-item-heading ml-2x mb-0 mime" (click)="displayPreview(att)" href="#" type="button" role="button">{{att.doc_name}}</button>
          <div class="delete">
            <button [disabled]="deleteDisabled$ | async"
                    class="btn btn-light btn-img"
                    (click)="openDeletingDialog(template, att)"
                    title="{{ 'COMMON_UI.FRAGEBOGEN.ANHAENGE.LOESCHEN' | translate }}">
              <em class="icon icon-svg icon-fi-loeschen"></em>
            </button>
          </div>
        </div>
      </li>
    </ul>
  </div>

  <div *ngIf="!(loading$ |async) && documents$.value && documents$.value.length > 0 ">

    <h2 class="mb-2x mt-3x">
      {{ 'COMMON_UI.FRAGEBOGEN.ANHAENGE.RUECKMELDUNG.TITEL' | translate }}
    </h2>
    <common-ui-card
      class="mb-4x"
      [message]="'COMMON_UI.FRAGEBOGEN.ANHAENGE.RUECKMELDUNG.MAILINFO' | translate"
      type="info">
    </common-ui-card>
    <common-ui-email [(data)]="data.email" [require]="true" [readonly]="isReadOnlyWrapper()"></common-ui-email>

  </div>

  <div class="mb-8x mw"></div>

  <ng-template #template>
    <div class="modal-container">
      <div class="modal-header">
        <h3 class="modal-title pull-left">{{ 'COMMON_UI.FRAGEBOGEN.ANHAENGE.LOESCHEN_DIALOG_TITEL' | translate }}</h3>
        <button (click)="modalRef.hide()" class="close pull-right" type="button"></button>
      </div>
      <div class="modal-body">
        <div>
          {{'COMMON_UI.FRAGEBOGEN.ANHAENGE.LOESCHEN_DIALOG_TEXT' | translate :{fileName: modalService.config.initialState.doc_name} }}
        </div>
        <div class="btn-bar save-btn mt-3x mb-3hxt">
          <button (click)="remove(modalService.config.initialState)" class="btn btn-danger"
                  type="button"> {{ 'COMMON_UI.FRAGEBOGEN.ANHAENGE.LOESCHEN' | translate }}
          </button>
          <button (click)="modalRef.hide()" class="btn btn-default"
                  type="button">{{ 'COMMON_UI.FRAGEBOGEN.ANHAENGE.LOESCHEN_ABBRECHEN' | translate }}
          </button>
        </div>
      </div>
    </div>
  </ng-template>

</div>
